// @flow

export default function isiOS() {
   return !!navigator.userAgent.match(/(iPad|iPhone|iPod)/g);
}
